export default "__VITE_ASSET__Ol4JiazT__"